import { baseRequest } from '@/utils/request'

export const BUSINESS_STATUS_GROUPS = {
	MEMBER_ACCOUNT: 'memberAccountStatuses',
	PRIMARY_CARD: 'primaryCardStatuses',
	CARD_ITEM_ASSET: 'cardItemAssetStatuses',
	PRODUCT_SALE: 'productSaleStatuses',
	SPA_ORDER: 'spaOrderStatuses',
	PRODUCT_ORDER: 'productOrderStatuses',
	RECHARGE_ORDER: 'rechargeOrderStatuses',
	TICKET_PACKAGE_ORDER: 'ticketPackageOrderStatuses',
	GIFT_RECHARGE_ORDER: 'giftRechargeOrderStatuses',
	GIFT_SEND: 'giftSendStatuses',
	SERVICE_ORDER: 'serviceOrderStatuses',
	STAFF: 'staffStatuses',
	ATTENDANCE_RECORD: 'attendanceRecordStatuses',
	ATTENDANCE_DAY: 'attendanceDayStatuses',
	PRODUCT_ORDER_REFUND: 'productOrderRefundStatuses',
	PRODUCT_ORDER_SHIPPING: 'productOrderShippingStatuses',
	RECHARGE_ORDER_REFUND: 'rechargeOrderRefundStatuses',
	ACTIVE: 'activeStatuses',
	STAFF_PAYROLL: 'staffPayrollStatuses',
	STORE: 'storeStatuses',
	ROOM: 'roomStatuses',
	APP_CATEGORY: 'appCategoryStatuses',
	ATTENDANCE_CONFIG: 'attendanceConfigStatuses',
	FEEDBACK: 'feedbackStatuses',
	DAREN_APPROVAL: 'darenApprovalStatuses',
	DAREN_PUBLISH: 'darenPublishStatuses',
	DAREN_SERVICE: 'darenServiceStatuses',
	LUCKY_START: 'luckyStartStatuses',
	LUCKY_USE: 'luckyUseStatuses',
	POINTS: 'pointsStatuses',
	POINTS_CONFIG: 'pointsConfigStatuses',
	ORDER_POINTS: 'orderPointsStatuses',
	SPA_ORDER_REFUND: 'spaOrderRefundStatuses',
	GIFT_RECHARGE_REFUND: 'giftRechargeRefundStatuses',
	VIRTUAL_SHIPPING: 'virtualShippingStatuses',
	SPA_ORDER_SHIPPING: 'spaOrderShippingStatuses',
	SERVICE_ITEM: 'serviceItemStatuses',
	RECHARGE_GIFT_ITEM: 'rechargeGiftItemStatuses',
	TICKET_PACKAGE_ITEM: 'ticketPackageItemStatuses',
	SPA_ITEM_USAGE: 'spaItemUsageStatuses',
	REVIEW_SCORE: 'reviewScoreStatuses',
	STAFF_COMMISSION_SETTLEMENT: 'staffCommissionSettlementStatuses',
	TICKET_PACKAGE_CONFIG: 'ticketPackageConfigStatuses',
	REFERRAL_REWARD: 'referralRewardStatuses',
	SHARE_CODE: 'shareCodeStatuses',
	INVOICE_RECORD: 'invoiceRecordStatuses',
	MOBILE_PAYMENT: 'mobilePaymentStatuses',
	BIZ_USER: 'bizUserStatuses',
	AI_FACE_READING: 'aiFaceReadingStatuses',
	AI_FACE_KNOWLEDGE: 'aiFaceKnowledgeStatuses',
	AI_FACE_KNOWLEDGE_RELEASE: 'aiFaceKnowledgeReleaseStatuses',
	SERVICE_WORK_ORDER_PROGRESS: 'serviceWorkOrderProgressStatuses',
	FRONT_DESK_STAFF: 'frontDeskStaffStatuses'
}

let contractPromise

const requiredGroups = Object.values(BUSINESS_STATUS_GROUPS)

const assertContract = (contract) => {
	requiredGroups.forEach((group) => {
		if (!Array.isArray(contract?.[group]) || contract[group].length === 0) {
			throw new Error(`业务状态契约缺少 ${group}`)
		}
		const codes = new Set()
		const keys = new Set()
		contract[group].forEach((option) => {
			if (option?.code === undefined || option?.code === null || !option?.key || !option?.label) {
				throw new Error(`业务状态契约 ${group} 存在不完整状态项`)
			}
			const code = String(option.code)
			if (codes.has(code)) {
				throw new Error(`业务状态契约 ${group} 存在重复状态码 ${code}`)
			}
			if (keys.has(option.key)) {
				throw new Error(`业务状态契约 ${group} 存在重复状态键 ${option.key}`)
			}
			codes.add(code)
			keys.add(option.key)
		})
	})
	return contract
}

export const loadBusinessStatusContract = () => {
	if (!contractPromise) {
		contractPromise = baseRequest('/biz/business/statusContract', {}, 'get')
			.then(assertContract)
			.catch((error) => {
				contractPromise = undefined
				throw error
			})
	}
	return contractPromise
}

export const resetBusinessStatusContract = () => {
	contractPromise = undefined
}

export const statusOptions = (contract, group) => {
	const options = contract?.[group]
	if (!Array.isArray(options)) {
		throw new Error(`业务状态契约未加载 ${group}`)
	}
	return options.map((item) => ({
		label: item.label,
		value: item.code
	}))
}

export const statusOption = (contract, group, code) => {
	if (code === undefined || code === null || code === '') {
		throw new Error(`业务状态契约 ${group} 收到空状态码`)
	}
	const options = contract?.[group]
	if (!Array.isArray(options)) {
		throw new Error(`业务状态契约未加载 ${group}`)
	}
	const option = options.find((item) => String(item.code) === String(code))
	if (!option) {
		throw new Error(`业务状态契约 ${group} 未定义状态码 ${code}`)
	}
	return option
}

export const tryStatusOption = (contract, group, code) => {
	if (code === undefined || code === null || code === '') {
		return undefined
	}
	const options = contract?.[group]
	if (!Array.isArray(options)) {
		return undefined
	}
	return options.find((item) => String(item.code) === String(code))
}

export const isStatus = (contract, group, code, key) =>
	tryStatusOption(contract, group, code)?.key === key

export const statusCodeByKey = (contract, group, key) => {
	const options = contract?.[group]
	if (!Array.isArray(options)) {
		throw new Error(`业务状态契约未加载 ${group}`)
	}
	const option = options.find((item) => item.key === key)
	if (!option) {
		throw new Error(`业务状态契约 ${group} 未定义状态键 ${key}`)
	}
	return option.code
}
